import * as React from "react";
import { OffsetText } from "src/Components/OffsetText";

export function twoPhrasePoem(
    firstPhrase: string,
    secondPhrase: string
): React.ReactNode {
    return (
        <div>
            <br />
            <br />
            <br />
            <div>{firstPhrase}</div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <OffsetText text={secondPhrase} />
        </div>
    );
}
